import Iframe from 'components/helpers/Iframe';

// export type EducationPageStoryBookProps = Routes.Fields.EducationCatalogPage;
export interface EducationPageStoryBookProps {
  fields: {
    podcastIFrameSrc: {
      value: string;
    };
    podcastTitle: {
      value: string;
    };
    height: {
      value: string;
    };
    width: {
      value: string;
    };
  };
}

const EducationPageStoryBook = ({ fields }: EducationPageStoryBookProps): JSX.Element => {
  return (
    <div
      data-component="authorable/pages/educationpagestorybook"
      className="mx-auto w-full max-w-screen-2xl"
    >
      <div>
        {fields?.podcastIFrameSrc?.value && (
          <Iframe
            src={fields?.podcastIFrameSrc?.value}
            width="100%"
            height="150"
            title={fields?.podcastTitle?.value}
          />
        )}
      </div>
    </div>
  );
};
export default EducationPageStoryBook;
